import ProjectProperties, {ProjectAvailableMenuOptions} from "../project-properties"
import projectProperties_toJSON from "../functions/properties-to-json";
import ProjectSession from "../../project-session";
import {ProjectPropertiesData} from "../../types"

const DEFAULT = {
    canCreateTask           : false,
    canCreateProject        : false,
    // canCreatePage           : false,
    canCreateLink           : false,
    canCreateEmbed          : false,
    canCreateMeeting        : false,
    canCreateEvent          : false,
    canCreateDiscussion     : false,
    canCreateDocument       : false,
    canCreateGoal           : false,
    canCreateDashboard      : false,
    canCreateRequestForms   : false,
    canCreateAttachments    : false,
}

export default class ProjectReportViewProperties extends ProjectProperties {

    constructor(properties:any, project:ProjectSession) {
        super(properties, project)

        this.canCreateTask                      = false
        this.canCreateProject                   = false
        // this.canCreatePage                      = _.get(properties,'canCreatePage', DEFAULT_VALUES.canCreatePage)
        this.canCreateLink                      = false
        this.canCreateEmbed                     = false
        this.canCreateMeeting                   = false
        this.canCreateEvent                     = false
        this.canCreateDiscussion                = false
        this.canCreateDocument                  = false
        this.canCreateGoal                      = false
        this.canCreateDashboard                 = false
        this.canCreateRequestForms              = false
        this.canCreateAttachments               = false
        this.canHaveStatus                      = false // View cant have status (!)

        this.menuSections.reports               = false
        this.menuSections.integrations          = false
        this.menuSections.automations           = false
        this.menuSections.customers             = false
        this.menuSections.settings              = false

        this.settingsSections.workItems         = false
        this.settingsSections.customFields      = false
        this.settingsSections.views             = false
        this.settingsSections.taskId            = false
        this.settingsSections.navigation        = false
        this.settingsSections.taskTypes         = false
        this.settingsSections.workflow          = false
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : false,
            info            : true,
            users           : true,
            settings        : false,
            status          : false,
            archive         : false,
            history         : false,
            rename          : true,
            editSource      : false,
            colorIcon       : true,
            move            : true,
            convert         : false,    // no convert please
            duplicate       : false,    // if change to true you need backend update !!!!!
            saveAsTemplate  : false,     // no save as template
            delete          : true,
            directLink      : true,
            showInMenu      : true,
        }
    }

    get handleExpandInsteadOfOpen() {
        return true
    }

    toJSON(): ProjectPropertiesData {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
